const pressReleasesURL = 'https://en-newsroom.nexon.com';

export default pressReleasesURL;
